// src/pages/auth/ForgotPassword.tsx
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errorHandler } from "@/lib/utils";
import { authService } from "@/services/api";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router";

export function ForgotPassword() {
  const [email, setEmail] = useState("");

  const forgotPassword = useMutation({
    mutationFn: (email: string) => authService.forgotPassword(email),
    onError: (error) =>
      errorHandler(error, "Ocorreu um erro ao enviar o email de recuperação."),
  });

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    forgotPassword.mutate(email);
  };

  if (forgotPassword.isSuccess) {
    return (
      <div className="text-center space-y-4">
        <h2 className="text-2xl font-bold text-gray-900">Email Enviado</h2>
        <p className="text-gray-600">
          Se existe uma conta associada ao email {email}, você receberá
          instruções para redefinir sua senha.
        </p>
        <Link to="/auth/login" className="block text-primary hover:underline">
          Voltar para o login
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-center text-gray-900">
          Recuperar Senha
        </h2>
        <p className="mt-2 text-sm text-gray-600 text-center">
          Digite seu email para receber instruções de recuperação de senha.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Email
          </label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1"
            required
          />
        </div>

        <Button
          type="submit"
          disabled={forgotPassword.isPending}
          className="w-full"
        >
          {forgotPassword.isPending ? "Enviando..." : "Enviar"}
        </Button>
      </form>

      <div className="text-center">
        <Link to="/auth/login" className="text-sm text-primary hover:underline">
          Voltar para o login
        </Link>
      </div>
    </div>
  );
}
